import { Log } from "../../../ng/src/app/logs/log.model";
import { SelfTemplated } from "./link.model";

export interface CreatedUpdated {
	created: string;
	updated: string;
}

export interface HasId {
	id: number
}

export class HasId {
	static compare(v1: HasId, v2: HasId) {
		return v1.id === v2.id;
	}
}

export interface HasIdName extends HasId {
	name: string;
}

export interface HasLog extends HasId {
	log: Log
}

export interface NameDescSort {
	name: string;
	description: string;
	sortOrder?: number;
}

export interface NameDescSortId extends NameDescSort, HasId { }

export interface KeyedValueItem<T extends number> extends NameDescSortId {
	id: T
}

export interface NameDescSortIdLinks extends NameDescSortId {
	_links: SelfTemplated;
}

export interface IdLabel extends HasId {
	label: string;
}

export interface PropertyMessage {
	property: string;
	message: string;
}

export interface ErrorMessage {
	errorMessage: string;
}

export interface ObjectKeyValueAny {
	[key: string]: any;
}

export type KnownKeys<T> = {
	[K in keyof T]: string extends K ? never : number extends K ? never : K
  } extends { [_ in keyof T]: infer U } ? U : never;

type NonFunctionPropertyNames<T> = {
	[K in keyof T]: T[K] extends Function ? never : K;
}[keyof T];

export type NonFunctionProperties<T> = Pick<T, NonFunctionPropertyNames<T>>;